"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _promise = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/promise"));
var _isArray = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/array/is-array"));
var _getOwnPropertyDescriptor = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor"));
var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/applyDecoratedDescriptor"));
var _webexCore = require("@webex/webex-core");
var _common = require("@webex/common");
var _peopleBatcher = _interopRequireDefault(require("./people-batcher"));
var _obj;
/**
 * @typedef {Object} PersonObject
 * @property {string} id - (server generated) Unique identifier for the person
 * @property {Array<email>} emails - Email addresses of the person
 * @property {string} displayName - Display name of the person
 * @property {isoDate} created - (server generated) The date and time that the person was created
 */

/**
 * @class
 */
var People = _webexCore.WebexPlugin.extend((_obj = {
  namespace: 'People',
  children: {
    batcher: _peopleBatcher.default
  },
  /**
   * Returns a single person by ID
   * @instance
   * @memberof People
   * @param {PersonObject|uuid|string} person
   * @returns {Promise<PersonObject>}
   * @example
   * webex.rooms.create({title: 'Get Person Example'})
   *   .then(function(room) {
   *     return webex.memberships.create({
   *       personEmail: 'alice@example.com',
   *       roomId: room.id
   *     });
   *   })
   *   .then(function(membership) {
   *     return webex.people.get(membership.personId);
   *   })
   *   .then(function(alice) {
   *     var assert = require('assert');
   *     assert(alice.id);
   *     assert(Array.isArray(alice.emails));
   *     assert.equal(alice.emails.filter(function(email) {
   *       return email === 'alice@example.com';
   *     }).length, 1);
   *     assert(alice.displayName);
   *     assert(alice.created);
   *     return 'success';
   *   });
   *   // => success
   */
  get: function get(person) {
    if (!person) {
      return _promise.default.reject(new Error('A person with an id is required'));
    }
    if (person === 'me') {
      return this._getMe();
    }
    var id = person.personId || person.id || person;
    return this.batcher.request(id);
  },
  /**
   * Returns a list of people
   * @instance
   * @memberof People
   * @param {Object | uuid[]} options or array of uuids
   * @param {email} options.email - Returns people with an email that contains this string
   * @param {string} options.displayName - Returns people with a name that contains this string
   * @param {bool} showAllTypes optional flag that requires Hydra to send every type field,
   * even if the type is not "person" (e.g.: SX10, webhook_integration, etc.)
   * @returns {Promise<Page<PersonObject>>}
   * @example
   * var room;
   * webex.rooms.create({title: 'List People Example'})
   *   .then(function(r) {
   *     room = r;
   *     return webex.memberships.create({
   *       personEmail: 'alice@example.com',
   *       roomId: room.id
   *     });
   *   })
   *   .then(function() {
   *     return webex.memberships.create({
   *       personEmail: 'bob@example.com',
   *       roomId: room.id
   *     });
   *   })
   *   .then(function() {
   *     return webex.people.list({email: 'alice@example.com'});
   *   })
   *   .then(function(people) {
   *     var assert = require('assert');
   *     assert.equal(people.length, 1);
   *     var person = people.items[0];
   *     assert(person.id);
   *     assert(Array.isArray(person.emails));
   *     assert(person.displayName);
   *     assert(person.created);
   *     return 'success';
   *   });
   *   // => success
   *  @example <caption>Example usage of array method</caption>
   * var room;
   * var aliceId;
   * var bobId;
   * webex.rooms.create({title: 'List People Array Example'})
   *   .then(function(r) {
   *     room = r;
   *     return webex.memberships.create({
   *       personEmail: 'alice@example.com',
   *       roomId: room.id
   *     });
   *   })
   *   .then(function(membership) {
   *     aliceId = membership.personId;
   *   })
   *   .then(function() {
   *     return webex.memberships.create({
   *       personEmail: 'bob@example.com',
   *       roomId: room.id
   *     });
   *   })
   *   .then(function(membership) {
   *     bobId = membership.personId;
   *   })
   *   .then(function() {
   *     return webex.people.list([aliceId, bobId]);
   *   })
   *   .then(function(people) {
   *     var assert = require('assert');
   *     assert.equal(people.length, 2);
   *     var person = people.items[0];
   *     assert(person.id);
   *     assert(Array.isArray(person.emails));
   *     assert(person.displayName);
   *     assert(person.created);
   *     return 'success';
   *   });
   *   // => success
   */
  list: function list(options) {
    var _this = this;
    if ((0, _isArray.default)(options)) {
      var peopleIds = options;
      return _promise.default.all(peopleIds.map(function (personId) {
        return _this.batcher.request(personId);
      }));
    }
    return this.request({
      service: 'hydra',
      resource: 'people',
      qs: options
    }).then(function (res) {
      return new _webexCore.Page(res, _this.webex);
    });
  },
  /**
   * Converts a uuid to a hydra id without a network dip.
   * @param {string} id
   * @private
   * @returns {string}
   */
  inferPersonIdFromUuid: function inferPersonIdFromUuid(id) {
    // base64.validate seems to return true for uuids, so we need a different
    // check
    try {
      if (_common.base64.decode(id).includes('ciscospark://')) {
        return id;
      }
    } catch (err) {
      // ignore
    }
    return _common.base64.encode("ciscospark://us/PEOPLE/".concat(id));
  },
  _getMe: function _getMe() {
    return this.webex.request({
      service: 'hydra',
      resource: 'people/me'
    }).then(function (res) {
      return res.body;
    });
  },
  version: "2.59.8"
}, ((0, _applyDecoratedDescriptor2.default)(_obj, "_getMe", [_common.oneFlight], (0, _getOwnPropertyDescriptor.default)(_obj, "_getMe"), _obj)), _obj));
var _default = People;
exports.default = _default;
//# sourceMappingURL=people.js.map
